import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: { title: '自述文件' },
            children:[
                {   path: '/dashboard',
                component: resolve => require(['../components/page/Dashboard.vue'], resolve),
                meta: { title: '系统首页' }
                },
                {   path: '/baseData_Xiehuijieshao',
                    component: resolve => require(['../components/page/baseData/Xiehuijieshao.vue'], resolve),
                    meta: { title: '协会介绍' , permission: true }
                },
                {   path: '/baseData_Xiehuizhangcheng',
                    component: resolve => require(['../components/page/baseData/Xiehuizhangcheng.vue'], resolve),
                    meta: { title: '协会章程' , permission: true }
                },
                {   path: '/baseData_Zuzhijiagou',
                    component: resolve => require(['../components/page/baseData/Zuzhijiagou.vue'], resolve),
                    meta: { title: '组织架构' , permission: true }
                },
                {   path: '/baseData_Dashiji',
                    component: resolve => require(['../components/page/baseData/Dashiji.vue'], resolve),
                    meta: { title: '大事记' , permission: true }
                },
                {   path: '/news_Hangyedongtai',
                    component: resolve => require(['../components/page/news/Hangyedongtai.vue'], resolve),
                    meta: { title: '行业动态' , permission: true }
                },
                {   path: '/news_Tongzhigonggao',
                    component: resolve => require(['../components/page/news/Tongzhigonggao.vue'], resolve),
                    meta: { title: '通知公告' , permission: true }
                },
                {   path: '/news_Zhanhuixinxi',
                    component: resolve => require(['../components/page/news/Zhanhuixinxi.vue'], resolve),
                    meta: { title: '展会信息' , permission: true }
                },
                {   path: '/news_Huiyuandongtai',
                    component: resolve => require(['../components/page/news/Huiyuandongtai.vue'], resolve),
                    meta: { title: '会员动态' , permission: true }
                },
                {   path: '/laws_Hangyewenjian',
                    component: resolve => require(['../components/page/laws/Hangyewenjian.vue'], resolve),
                    meta: { title: '行业文件' , permission: true }
                },
                {   path: '/laws_Hangyezhengce',
                    component: resolve => require(['../components/page/laws/Hangyezhengce.vue'], resolve),
                    meta: { title: '行业政策' , permission: true }
                },
                {   path: '/laws_Xiehuibiaozhun',
                    component: resolve => require(['../components/page/laws/Xiehuibiaozhun.vue'], resolve),
                    meta: { title: '协会标准' , permission: true }
                },
                {   path: '/style_Huiyuanfengcai',
                    component: resolve => require(['../components/page/style/Huiyuanfengcai.vue'], resolve),
                    meta: { title: '会员风采' , permission: true }
                },
                {   path: '/style_Chanpinjianjie',
                    component: resolve => require(['../components/page/style/Chanpinjianjie.vue'], resolve),
                    meta: { title: '产品简介' , permission: true }
                },
                {   path: '/style_Qiyejidi',
                    component: resolve => require(['../components/page/style/Qiyejidi.vue'], resolve),
                    meta: { title: '企业基地' , permission: true }
                },
                {   path: '/other_Huiyuanshenqing',
                    component: resolve => require(['../components/page/other/Huiyuanshenqing.vue'], resolve),
                    meta: { title: '会员申请' , permission: true }
                },
                {   path: '/other_Wenjianxiazai',
                    component: resolve => require(['../components/page/other/Wenjianxiazai.vue'], resolve),
                    meta: { title: '文件下载' , permission: true }
                },
                {   path: '/other_Lianxiwomen',
                    component: resolve => require(['../components/page/other/Lianxiwomen.vue'], resolve),
                    meta: { title: '联系我们' , permission: true }
                },
                {   path: '/other_Youjizhishi',
                    component: resolve => require(['../components/page/other/Youjizhishi.vue'], resolve),
                    meta: { title: '有机知识' , permission: true }
                },
                {
                    path: '/system_baseDataManage',
                    component: resolve => require(['../components/page/system/baseDataManage.vue'], resolve),
                    meta: { title: '基础数据' , permission: true }
                },
                {
                    path: '/system_rightManage',
                    component: resolve => require(['../components/page/system/rightManage.vue'], resolve),
                    meta: { title: '权限管理' , permission: true }
                },
                {
                    path: '/system_userManage',
                    component: resolve => require(['../components/page/system/userManage.vue'], resolve),
                    meta: { title: '用户管理' , permission: true }
                },
                {
                    path: '/404',
                    component: resolve => require(['../components/page/404.vue'], resolve),
                    meta: { title: '404' , permission: false }
                },
                {
                    path: '/403',
                    component: resolve => require(['../components/page/403.vue'], resolve),
                    meta: { title: '403' , permission: false }
                }
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/Login.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js